module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA2klEQVQ4T2NkoBAwoutXqfjvwPCX4f+dbsaDxJgNNuDPTuEARgZG/TXPogOe/5A2OHnuHsNpoekb73QyBhAyBGLADpH/yAqLZnxhuCi1iOEZbyiG/v//GQrvdDFOgElgNeDBy78MTKy893h5OT6hm8DC+OcPL8unL6n9n3/O3/nTA6sBhJwNkncu+8hw8NJvxlEDhnQYCAe/Zfj49T8kGheU8d6/9+yvAjHxD1Jz8d4fhhuP//64+fgvJzwzFQWxhf/8zShJjCHsrP+f9637tRKkFiM3EmMAshoAaLx+ESWKXj8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ztree/root.png
// module id = eqMh
// module chunks = 1